import { render } from "./Filters.vue?vue&type=template&id=81f85ade"
import script from "./Filters.vue?vue&type=script&setup=true&lang=js"
export * from "./Filters.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Filter/Filters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81f85ade"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81f85ade', __exports__)) {
    api.reload('81f85ade', __exports__)
  }
  
  module.hot.accept("./Filters.vue?vue&type=template&id=81f85ade", () => {
    api.rerender('81f85ade', render)
  })

}


export default __exports__